/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UserGroupAssignmentUser } from './UserGroupAssignmentUser';
import {
    UserGroupAssignmentUserFromJSON,
    UserGroupAssignmentUserFromJSONTyped,
    UserGroupAssignmentUserToJSON,
} from './UserGroupAssignmentUser';

/**
 * 
 * @export
 * @interface UserGroupAssignment
 */
export interface UserGroupAssignment {
    /**
     * 
     * @type {string}
     * @memberof UserGroupAssignment
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupAssignment
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroupAssignment
     */
    user_group_id: string;
    /**
     * 
     * @type {UserGroupAssignmentUser}
     * @memberof UserGroupAssignment
     */
    user?: UserGroupAssignmentUser;
}

/**
 * Check if a given object implements the UserGroupAssignment interface.
 */
export function instanceOfUserGroupAssignment(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "user_id" in value;
    isInstance = isInstance && "user_group_id" in value;

    return isInstance;
}

export function UserGroupAssignmentFromJSON(json: any): UserGroupAssignment {
    return UserGroupAssignmentFromJSONTyped(json, false);
}

export function UserGroupAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroupAssignment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'user_id': json['user_id'],
        'user_group_id': json['user_group_id'],
        'user': !exists(json, 'user') ? undefined : UserGroupAssignmentUserFromJSON(json['user']),
    };
}

export function UserGroupAssignmentToJSON(value?: UserGroupAssignment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'user_id': value.user_id,
        'user_group_id': value.user_group_id,
        'user': UserGroupAssignmentUserToJSON(value.user),
    };
}

